import { render } from "./RecruitmentEmailTemplateDrawer.vue?vue&type=template&id=45018459&scoped=true"
import script from "./RecruitmentEmailTemplateDrawer.vue?vue&type=script&lang=js"
export * from "./RecruitmentEmailTemplateDrawer.vue?vue&type=script&lang=js"

import "./RecruitmentEmailTemplateDrawer.vue?vue&type=style&index=0&id=45018459&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45018459"]])

export default __exports__